module.exports = __webpack_public_path__ + "static/media/pro.b9d53f88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/airpods/pro.png
// module id = 1141
// module chunks = 0